import React from 'react';
import MetaDataItem from '../MetaDataItem';
import { StyledMetadataList, MetadataListSubGroup, NoMetaDataMessage } from './MetaDataList.style';
import Accordion from '@Components/Accordion';
import { MessageBar } from '@Components/MessageBar';
const MetaDataList = ({ metalist, isSubGroup, listName }) =>
    isSubGroup ? (
        <MetadataListSubGroup>
            <Accordion title={listName}>
                <StyledMetadataList className="accordion-list sub-group" isSubGroup={isSubGroup}>
                    {metalist.map(item => <MetaDataItem {...item} key={item.name} />)}
                </StyledMetadataList>
            </Accordion>
        </MetadataListSubGroup>
    ) : (
        <>
            {metalist ? (
                <StyledMetadataList
                    className="accordion-list"
                    isSubGroup={isSubGroup}
                    data-testid="labels_wrapper"
                >
                    {metalist.map((item, index) => (
                        <MetaDataItem {...item} key={item.name} labelIndex={index} />
                    ))}
                </StyledMetadataList>
            ) : (
                <NoMetaDataMessage data-testid="no-data-msg">
                    <MessageBar message="No labels available. Make sure to run an analysis to add some labels." />
                </NoMetaDataMessage>
            )}
        </>
    );

export default MetaDataList;
